import {connect} from 'react-redux';
import Dashboard from '../Dashboard/Dashboard';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState) => {
   return {
      canCreateReviews: state.authorization.authorizedActions.canCreateReviews
   };
};

export default connect(mapStateToProps, null)(Dashboard);
